import React, { useContext, useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContextAdmin } from '../context/AuthContextAdmin';
import { firestore } from '../Firebase';

const HeaderAdmin = ({ name }) => {
  const { logoutAdmin } = useContext(AuthContextAdmin) || {};
  const [hasRegistration, setHasRegistration] = useState(false);

  useEffect(() => {
    const unsubscribe = firestore
      .collection('settings')
      .doc('features')
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            setHasRegistration(doc.data().hasRegistration || false);
          }
        },
        (error) => {
          console.error('Error listening to features changes:', error);
        }
      );

    return () => unsubscribe();
  }, []);

  return (
    <Navbar expand="sm" className="bg-body-tertiary pop3d">
      <Container fluid>
        <Navbar.Brand>Zcast</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/admin">
              Admin
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/settings">
              Settings
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/loginsessions">
              Login Sessions
            </Nav.Link>
            {hasRegistration && (
              <Nav.Link as={Link} to="/admin/registeredusers">
                Registered Users
              </Nav.Link>
            )}
            <Nav.Link as={Link} to="/" target="_blank">
              User Login
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <button className="btn btn-primary" onClick={logoutAdmin}>
              Logout
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderAdmin;
